(function() {
  'use strict';
  angular.module('benefits')
  .component('dateInfo', {
    bindings: {
      refId: '='
    },
    controller: ['benefitService', function dateInfoController(benefitService) {
      var ctrl = this;
      this.$onInit = function() {
        benefitService.planSummaryPromise.then(function(data) {
          ctrl.model = data;
        });
      };
    }],
    templateUrl: '/js/benefits/dateInfo.html' + appVersion
  });
})();
